import { useEffect, useState } from "react";
import GetHandheldsByFacility from "../../data_layer/repositories/Handhelds/GetHandheldsByFacility";

export const useGetHandheldsByFacility = (facility_id) => {

    const [isLoading, setIsLoading] = useState(true);
    const [handhelds, setHandhelds] = useState([]);

    useEffect(() => {
        if (facility_id)
            getHandhelds();
    }, [facility_id]);

    const getHandhelds = async () => {
        setIsLoading(true);
        
        const response = await GetHandheldsByFacility(facility_id) 

        setHandhelds(response.sort((a, b) => a.serial_number > b.serial_number ? 1 : -1));
        setIsLoading(false);
    }

    const reloadData = () => {
        if (facility_id)
            getHandhelds();
    }


    return {
        isLoading,
        handhelds,
        reloadData,
    }
}
